import API_URLS from '../config/apiConfig';
import { apiGet } from '../utils/apiUtils';

export interface StorePosMappingOptionsResponse {
  financial_event: string[];
  transaction_line: string[];
  lotto_merch_description: string[];
}

const EMPTY_OPTIONS: StorePosMappingOptionsResponse = {
  financial_event: [],
  transaction_line: [],
  lotto_merch_description: [],
};

const normalizeOptions = (
  payload: Partial<StorePosMappingOptionsResponse> | null | undefined
): StorePosMappingOptionsResponse => {
  const data = payload ?? {};

  return {
    financial_event: Array.isArray(data.financial_event) ? data.financial_event : [],
    transaction_line: Array.isArray(data.transaction_line) ? data.transaction_line : [],
    lotto_merch_description: Array.isArray(data.lotto_merch_description) ? data.lotto_merch_description : [],
  };
};

class StorePosMappingOptionsService {
  async getOptions(storeId: string): Promise<StorePosMappingOptionsResponse> {
    if (!storeId) {
      return EMPTY_OPTIONS;
    }

    const payload = await apiGet(API_URLS.GET_STORE_POS_MAPPING_OPTIONS(storeId));
    return normalizeOptions(payload as Partial<StorePosMappingOptionsResponse>);
  }
}

const storePosMappingOptionsService = new StorePosMappingOptionsService();
export default storePosMappingOptionsService;
